// extracted by mini-css-extract-plugin
export default {"wrapper":"Overlay_wrapper__PQoph","menu":"Overlay_menu__qfykc","backdrop":"Overlay_backdrop__z+V-P"};